
let search = window.location.search;
let index = search.indexOf('=')
let query = search.substr(index + 1, search.length - index);
if (query > 1) {
  $('.blog-recommend').hide();
}


let pathname = location.pathname;
let arr = pathname.split('/');
let tag = arr[arr.length - 1];
let tagList = document.querySelectorAll('.blog-tags-list li');
if(pathname.includes('tagged')){
  tagList.forEach(item => {
    let currentTag = $(item).data('tag');
    if (currentTag == tag) {
      $(item).addClass('active');
    }
  })
}


let menuList = document.querySelectorAll('.blog-menu-list .blog-menu-item');
let title;
menuList && menuList.forEach(item => {
  if ($(item).find('.blog-menu-title').hasClass('on')) {
    title = $(item).find('.blog-menu-title').find('span').text()
  }
})
let li = document.querySelectorAll(`.blog-menu-item .blog-menu-list li`);
li && li.forEach(item => {
  if ($(item).hasClass('on')) {
    title = $(item).find('a').text();
  }
})
$('.current-menu').val(title)

$('.blog-menu-input').click(function () {
  $(this).find('.iconfont').toggleClass('on')
  $('.blog-menu-box').slideToggle();
})